import { ZonesOverlayFeatureStateObject } from 'components/MapBox/ZonesOverlay/ZonesOverlay';
import { AreaRating } from 'const/AreaRating';
import React, { useEffect, useState } from 'react';
import { RatingSummary } from '../RatingSummary';

interface RatingSelectionProps {
  selected: AreaRating;
  areas: ZonesOverlayFeatureStateObject[];
  onChange: (newRatingType: AreaRating) => void;
}

export const RatingSelection = ({
  onChange,
  ...props
}: RatingSelectionProps) => {
  const [activeSelection, setActiveSelection] = useState(props.selected);
  const [likedAreaCount, setLikedAreaCount] = useState(0);
  const [dislikedAreaCount, setDislikedAreaCount] = useState(0);

  /**
   * Note :
   * We have to minimize any looping.
   * Count the LIKE/DISLIKE area using `map` to make it loop once.
   * If we use `filter`, it will run 2 times loop.
   */
  useEffect(() => {
    let newLikedAreaCount = 0;
    let newDislikedAreaCount = 0;

    props.areas.map(area => {
      switch (area.value?.rating) {
        case AreaRating.LIKE:
          newLikedAreaCount++;
          break;
        case AreaRating.DISLIKE:
          newDislikedAreaCount++;
          break;
        default:
          /* Do nothing because we only need to count the rated area */
          break;
      }
      return true;
    });
    setLikedAreaCount(newLikedAreaCount);
    setDislikedAreaCount(newDislikedAreaCount);
  }, [props.areas]);

  const onClickRatingSummary = (type: AreaRating) => {
    setActiveSelection(type);
    onChange(type);
  };

  return (
    <>
      <p>
        To mark multiple zones, select one of the options below, then select the
        relevant zones.
      </p>
      <RatingSummary
        active={activeSelection === AreaRating.LIKE}
        count={likedAreaCount}
        onClick={onClickRatingSummary}
        type={AreaRating.LIKE}
      />
      <RatingSummary
        active={activeSelection === AreaRating.DISLIKE}
        count={dislikedAreaCount}
        onClick={onClickRatingSummary}
        type={AreaRating.DISLIKE}
      />
    </>
  );
};
